import React, { Component } from 'react'

// components
import Sidemenu from '../../../components/sidemenu'
import Header from '../../../components/dashHeader'

//css 
import '../../styles/dashboard/Home.css'

//assets
import Load from '../../../assets/svg/other/loading2.svg'


export default class Social extends Component {

    state = {
        unVerifiedShow: true,
    };

    componentDidMount() {

        const urlParam = window.location.search;
        // const urlParam = URL();

        console.log(urlParam)

        localStorage.setItem("tokenset1", urlParam)

        // setTimeout(() => {
        //     window.location ="/dashboard/home";
        // }, 3200);

        // const token = localStorage.getItem("tokenset");
        // if (token === null ) {
        //     window.location="/"
        // }
    }

    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />

                <section className="Home">
                    <div className="home-container">
                        
                        {/* <div className="load-animation">
                            <img  className="icon-load" src={Loadicon}  alt="loading"/> 
                        </div> */}
                        <div className="load-animation" id="load">
                            <img src={Load}  alt="loading"/>
                        </div>
                    </div>
                </section>
                
            </div>
        )
    }
}
